@if (listing && content) {
<div class="wrap">
    <!-- top text section-->

    <p class="m-t m-t-3-s h4"
       *iCms="'title' of content; skipEmpty: true"></p>
    @if(!content.hideFilters) {
    <div class="p-b-10 center">
        <action *ifSize="'SM'"
                class="button no-wrap"
                [iCmsModalOpen]="'ugcImageForm'">
            {{'Upload your image' | translate}}
        </action>
    </div>
    }
    <div *ngIf="!content.hideFilters"
         class="w-12 overflow-x-auto custom-scrollbar flex flex-justify-between">
        <div class="flex">
            @for (option of visibleFilterOptions; track option) {
            <div class="inline-block m-r-2 p-l-2 p-r-2 m-b-2 no-wrap"
                 [ngClass]="isFilterOptionSelected(option.key) ? 'button' : 'button-1'"
                 (click)="toggleFilterOption(option.key)">
                {{option.title}}
            </div>
            }
        </div>
        <action *ifSize="'XL'"
                class="button inline-block m-r-2 m-b-2 no-wrap"
                [iCmsModalOpen]="'ugcImageForm'">
            {{'Upload your image' | translate}}
        </action>
    </div>
    <!-- images -->
    <div class="m-t-6 m-t-3-s m-t-3-m m-b-3-s m-b-3-m">
        <!-- image list -->
        <div [grid]="[2, 3, 5, 5][client.sizeId]"
             [gridColumnGap]="2"
             [gridRowGap]="2">
            @for (model of listing?.models; track model.id) {
            <ugc-image-item [shopTheLook]="content.showShopTheLook"
                            [model]="model"></ugc-image-item>
            }
        </div>
    </div>
    <!-- view more and qty viewed -->
    @if (listing.getTotal() > content.infScrollStep) {
    <div class="p-t-10 p-t-6-s p-b-10 p-b-6-s m-t-1 center">
        <!-- number of viewed elements  -->
        <p *ngIf="!content.hideViewMoreInfo"
           class="p1 col-1  m-b-5">{{ 'You’ve viewed % of % homes' | translate : listing.visibleQty :
            listing.getTotal() }}</p>
        <!-- view more button -->
        @if (listing.hasMore) {
        <button class="button-1 bg-col-w p-r-5 p-l-5 b-a b-col-1"
                role="button"
                (click)="increaseLimit()"
                [attr.aria-label]="'View more' | translate">{{'View more' | translate}}</button>
        }
    </div>
    }
    <!-- no items info -->
    <p class="w-10 w-12-m w-11-s col-11 m-t-10-m m-t-10-s p-b-8-s p1"
       *iCms="'message' of content; content: 'html'; skipEmpty: true"></p>
</div>
}